var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"content"},[_c('br'),(_vm.username)?_c('status'):(_vm.code || _vm.token)?_c('codee',{attrs:{"code":_vm.code}}):_c('login')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }